document.addEventListener('DOMContentLoaded', function() {
    // Initialize all functionality
    initializeNavigation();
    initializeScrollEffects();
    initializeProjectCards();
    initializeContactForm();
    initializeIntersectionObserver();
    // initializeHeroImageRotation(); // Disabled - using hero-carousel.js instead
    initializeLoadingStates();
    initializeCountUpAnimation();
});

// Hero image rotation functionality
function initializeHeroImageRotation() {
    const heroImageContainer = document.querySelector('.hero-image-container');
    if (!heroImageContainer) return;
    
    // Images from the projects grid section and new 2024 images
    const heroImages = [
        '/images/projects/hero-main.jpg',
        '/images/projects/project-01.jpg',
        '/images/projects/project-02.jpg',
        '/images/projects/project-03.jpg',
        '/images/2023/Kram-Ark-1-of-10.jpg',
        '/images/2024/IMG_9761.jpg',
        '/images/projects/interior-01.jpg',
        '/images/2023/Kram-Ark-3-of-10.jpg',
        '/images/2024/EFTER_8424.jpg',
        '/images/projects/project-05.jpg',
        '/images/2024/IMG_9689.jpg',
        '/images/2024/IMG_9691.jpg',
        '/images/2024/IMG_9698.jpg'
    ];
    
    let currentImageIndex = 0;
    
    // Set up container for sliding effect
    heroImageContainer.style.position = 'relative';
    heroImageContainer.style.overflow = 'hidden';
    
    function rotateHeroImage() {
        const currentImg = heroImageContainer.querySelector('.hero-img');
        if (!currentImg) return;
        
        currentImageIndex = (currentImageIndex + 1) % heroImages.length;
        const nextImageSrc = heroImages[currentImageIndex];
        
        // Create new image element
        const nextImg = document.createElement('img');
        nextImg.src = nextImageSrc;
        nextImg.alt = 'Moderne arkitektur';
        nextImg.className = 'hero-img';
        nextImg.style.position = 'absolute';
        nextImg.style.top = '0';
        nextImg.style.left = '0';
        nextImg.style.width = '100%';
        nextImg.style.height = '100%';
        nextImg.style.objectFit = 'cover';
        nextImg.style.transform = 'translateX(100%)';
        nextImg.style.transition = 'transform 0.8s ease-in-out';
        
        // Add new image to container
        heroImageContainer.appendChild(nextImg);
        
        // Wait for image to load
        nextImg.onload = () => {
            // Start slide animation
            requestAnimationFrame(() => {
                currentImg.style.transform = 'translateX(-100%)';
                currentImg.style.transition = 'transform 0.8s ease-in-out';
                nextImg.style.transform = 'translateX(0)';
                
                // Remove old image after animation
                setTimeout(() => {
                    if (currentImg.parentNode) {
                        currentImg.remove();
                    }
                }, 800);
            });
        };
        
        // Handle image load error
        nextImg.onerror = () => {
            nextImg.remove();
        };
    }
    
    // Start rotation after 5 seconds, then every 5 seconds
    setTimeout(() => {
        rotateHeroImage();
        setInterval(rotateHeroImage, 5000);
    }, 5000);
}

// Navigation functionality
function initializeNavigation() {
    const navToggle = document.getElementById('nav-toggle');
    const navMenu = document.getElementById('nav-menu');
    const navLinks = document.querySelectorAll('.nav-link[href^="#"]');
    const header = document.querySelector('.header');
    
    // Mobile menu toggle
    if (navToggle && navMenu) {
        navToggle.addEventListener('click', function() {
            navMenu.classList.toggle('active');
            navToggle.classList.toggle('active');
        });
    }
    
    // Smooth scroll for navigation links
    navLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
                const headerHeight = header ? header.offsetHeight : 80;
                const targetPosition = targetElement.offsetTop - headerHeight;
                
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
                
                // Close mobile menu if open
                if (navMenu && navMenu.classList.contains('active')) {
                    navMenu.classList.remove('active');
                    navToggle.classList.remove('active');
                }
            }
        });
    });
}

// Header scroll effects
function initializeScrollEffects() {
    const header = document.querySelector('.header');
    let lastScrollTop = 0;
    let ticking = false;
    
    function updateHeader() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 100) {
            header.style.background = 'rgba(255, 255, 255, 0.98)';
            header.style.boxShadow = '0 2px 20px rgba(0, 0, 0, 0.1)';
        } else {
            header.style.background = 'rgba(255, 255, 255, 0.95)';
            header.style.boxShadow = 'none';
        }
        
        lastScrollTop = scrollTop;
        ticking = false;
    }
    
    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(updateHeader);
            ticking = true;
        }
    }
    
    window.addEventListener('scroll', requestTick);
}

// Project cards hover effects
function initializeProjectCards() {
    const projectCards = document.querySelectorAll('.project-card, .project-item');
    
    projectCards.forEach(card => {
        card.addEventListener('mouseenter', function() {
            this.style.zIndex = '10';
        });
        
        card.addEventListener('mouseleave', function() {
            this.style.zIndex = '1';
        });
        
        // Add click functionality for project items
        if (card.classList.contains('project-item')) {
            card.addEventListener('click', function() {
                // Project click handler - navigation handled elsewhere
            });
        }
    });
}

// Intersection Observer for scroll animations
function initializeIntersectionObserver() {
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
                
                // Add staggered animation for children if they exist
                const children = entry.target.querySelectorAll('.project-card, .service-card, .stat');
                children.forEach((child, index) => {
                    setTimeout(() => {
                        child.style.opacity = '1';
                        child.style.transform = 'translateY(0)';
                    }, index * 100);
                });
            }
        });
    }, observerOptions);
    
    // Observe elements for scroll animations
    const animateElements = document.querySelectorAll(`
        .section-header,
        .about-content,
        .services-grid,
        .contact-content,
        .projects-featured,
        .hero-content,
        .hero-image
    `);
    
    animateElements.forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(el);
        
        // Set up children for staggered animation
        const children = el.querySelectorAll('.project-card, .service-card, .stat');
        children.forEach(child => {
            child.style.opacity = '0';
            child.style.transform = 'translateY(20px)';
            child.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
        });
    });
}

// Utility functions
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

function throttle(func, limit) {
    let inThrottle;
    return function() {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit);
        }
    }
}

// Lazy loading for images
function initializeLazyLoading() {
    const images = document.querySelectorAll('img[loading="lazy"]');
    
    if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    img.src = img.dataset.src || img.src;
                    img.classList.remove('lazy');
                    imageObserver.unobserve(img);
                }
            });
        });
        
        images.forEach(img => imageObserver.observe(img));
    } else {
        // Fallback for older browsers
        images.forEach(img => {
            img.src = img.dataset.src || img.src;
        });
    }
}

// Initialize lazy loading when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeLazyLoading);
} else {
    initializeLazyLoading();
}

// Performance optimization: Preload critical resources
function preloadCriticalResources() {
    const criticalImages = [
        '../staging-1757159774/wp-content/uploads/2023/10/Kram-Ark-1-of-10.jpg',
        '../staging-1757159774/wp-content/uploads/2023/10/KRAM-logo-aflang.png'
    ];
    
    criticalImages.forEach(src => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = src;
        document.head.appendChild(link);
    });
}

// Call preload function
preloadCriticalResources();

// Counter animation for stats
function initializeCountUpAnimation() {
    const stats = document.querySelectorAll('.stat-number');
    
    const observerOptions = {
        threshold: 0.8,
        rootMargin: '0px'
    };
    
    const countUp = (element, target, duration = 2000) => {
        const start = 0;
        const startTime = Date.now();
        
        const update = () => {
            const elapsed = Date.now() - startTime;
            const progress = Math.min(elapsed / duration, 1);
            
            // Easing function for smooth animation
            const easeOutExpo = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
            const current = Math.round(start + (target - start) * easeOutExpo);
            
            const symbol = element.getAttribute('data-symbol') || '+'; // Default to '+' if no data-symbol is provided
            element.textContent = current + symbol;
            
            if (progress < 1) {
                requestAnimationFrame(update);
            }
        };
        
        requestAnimationFrame(update);
    };
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const originalText = entry.target.textContent;
                const number = parseInt(originalText.replace(/\D/g, ''));
                
                if (!isNaN(number)) {
                    countUp(entry.target, number);
                    observer.unobserve(entry.target);
                }
            }
        });
    }, observerOptions);
    
    stats.forEach(stat => observer.observe(stat));
}

// Loading states for images
function initializeLoadingStates() {
    const images = document.querySelectorAll('img[loading="lazy"]');
    
    images.forEach(img => {
        img.style.opacity = '0';
        img.style.transition = 'opacity 0.5s ease';
        
        img.addEventListener('load', () => {
            img.style.opacity = '1';
        });
        
        // Handle images that are already loaded
        if (img.complete && img.naturalHeight !== 0) {
            img.style.opacity = '1';
        }
    });
}



// Enhanced contact form with Web3Forms integration
function initializeContactForm() {
    const contactForm = document.getElementById('form');
    
    if (contactForm) {
        // Add input validation styling
        const inputs = contactForm.querySelectorAll('input, textarea');
        inputs.forEach(input => {
            input.addEventListener('blur', function() {
                if (this.value.trim()) {
                    this.classList.add('has-value');
                } else {
                    this.classList.remove('has-value');
                }
                
                // Simple validation
                if (this.required && !this.value.trim()) {
                    this.classList.add('error');
                } else {
                    this.classList.remove('error');
                }
                
                // Email validation
                if (this.type === 'email' && this.value.trim()) {
                    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailPattern.test(this.value)) {
                        this.classList.add('error');
                    } else {
                        this.classList.remove('error');
                    }
                }
            });
        });
        
        const submitBtn = contactForm.querySelector('button[type="submit"]');
        
        contactForm.addEventListener('submit', async function(e) {
            e.preventDefault();
            
            const formData = new FormData(contactForm);
            let hasErrors = false;
            
            // Validate required fields
            formData.forEach((value, key) => {
                const input = contactForm.querySelector(`[name="${key}"]`);
                if (input && input.required && !value.trim()) {
                    input.classList.add('error');
                    hasErrors = true;
                }
            });
            
            if (hasErrors) {
                showFormMessage('Udfyld venligst alle påkrævede felter', 'error');
                return;
            }
            
            // Access key is already in the HTML form, no need to append
            
            const originalText = submitBtn.textContent;
            
            submitBtn.textContent = "Sender...";
            submitBtn.disabled = true;
            submitBtn.classList.add('loading');
            
            // Remove any existing messages
            removeFormMessage();
            
            try {
                const response = await fetch("https://api.web3forms.com/submit", {
                    method: "POST",
                    body: formData
                });
                
                const data = await response.json();
                
                if (response.ok) {
                    // Success state
                    submitBtn.textContent = "✓ Sendt!";
                    submitBtn.classList.remove('loading');
                    submitBtn.classList.add('success');
                    
                    showFormMessage('Tak for din besked! Vi vender tilbage hurtigst muligt.', 'success');
                    
                    // Reset the form
                    contactForm.reset();
                    inputs.forEach(input => {
                        input.classList.remove('has-value', 'error');
                    });
                    
                    // Reset button state after showing success message
                    setTimeout(() => {
                        submitBtn.textContent = originalText;
                        submitBtn.disabled = false;
                        submitBtn.classList.remove('success');
                        removeFormMessage();
                    }, 3000);
                } else {
                    // Error from API
                    throw new Error(data.message || 'Form submission failed');
                }
                
            } catch (error) {
                console.error('Form submission error:', error);
                
                // Error state
                submitBtn.textContent = originalText;
                submitBtn.disabled = false;
                submitBtn.classList.remove('loading');
                submitBtn.classList.add('error');
                
                showFormMessage('Der opstod en fejl ved afsendelse. Prøv venligst igen eller kontakt os direkte.', 'error');
                
                // Reset button error state after 3 seconds
                setTimeout(() => {
                    submitBtn.classList.remove('error');
                }, 3000);
            }
        });
    }
}

// Helper function to show form messages
function showFormMessage(message, type) {
    const contactForm = document.querySelector('.form');
    if (!contactForm) return;
    
    removeFormMessage();
    
    const messageDiv = document.createElement('div');
    messageDiv.className = `form-message form-message-${type}`;
    messageDiv.textContent = message;
    messageDiv.style.cssText = `
        padding: 1rem;
        margin-bottom: 1rem;
        border-radius: 8px;
        font-size: 0.95rem;
        animation: slideDown 0.3s ease;
    `;
    
    if (type === 'success') {
        messageDiv.style.backgroundColor = '#d4edda';
        messageDiv.style.color = '#155724';
        messageDiv.style.border = '1px solid #c3e6cb';
    } else if (type === 'error') {
        messageDiv.style.backgroundColor = '#f8d7da';
        messageDiv.style.color = '#721c24';
        messageDiv.style.border = '1px solid #f5c6cb';
    }
    
    contactForm.insertBefore(messageDiv, contactForm.firstChild);
}

// Helper function to remove form messages
function removeFormMessage() {
    const existingMessage = document.querySelector('.form-message');
    if (existingMessage) {
        existingMessage.remove();
    }
}

// Add CSS for form animations only (mobile menu styles moved to style.css)
const style = document.createElement('style');
style.textContent = `
    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
    
    .btn-primary.loading {
        opacity: 0.7;
        cursor: not-allowed;
    }
    
    .btn-primary.success {
        background: #28a745;
        border-color: #28a745;
    }
    
    .btn-primary.error {
        background: #dc3545;
        border-color: #dc3545;
        animation: shake 0.5s;
    }
    
    @keyframes shake {
        0%, 100% { transform: translateX(0); }
        25% { transform: translateX(-10px); }
        75% { transform: translateX(10px); }
    }
`;
document.head.appendChild(style);
